import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React, {useEffect, useState} from "react"

import styles from "./FeaturesNavigationLink.module.scss"
import Link from "@components/Theme/Link/Link"
type Props = {
	data: AdvancedSideAssetMainContent
	active: boolean
	id: number
}

const FeaturesNavigationLink = (props: Props) => {
	const image = props.active ? props.data.preview : props.data.inside

	return (
		<Link
			className={`${styles.featuresLink} ${
				props.active ? styles.active : ""
			}`}
			link={
				props.data.buttons?.[0].link ? props.data.buttons?.[0].link : ""
			}
		>
			{image && props.active && (
				<NewResponsiveImage
					containerClassName={styles.image}
					{...image}
					alt={props.data.title ?? image?.alt}
				/>
			)}
			<Typography
				id={`${props.id}`}
				className={`${styles.featuresTitleLink} ${
					props.active ? styles.active : ""
				}`}
				content={props.data.title}
				variant={Variant.Paragraph}
				capitalize
			/>
		</Link>
	)
}

export default FeaturesNavigationLink
